<template>
    <div class="flex">
        <div class="row">
          <div class="flex md12 sm12">
            <sp-360-panel :title="$t('assistencia.servicos.tabela.titulo', {regiao : subSel? subSel.nome : 'Municipio'})" id="painelSup" :footerText=" $t('rodape.fonteData', {fonte: fonte, data: dataRef } )" :footerComplementar="$t('assistencia.servicos.rodape')">
                <div class="flex sm12 md3 lg3">
                    <multiselect id="selectSubprefeituras" name="Subprefeituras" placeholder="Selecione uma Subprefeitura"
                    track-by="nome" label="nome" :value="subSel" :options="subs" :close-on-select="true" :show-labels="false"
                    @input="updateMultiSelect" />
                </div>
                <div class="flex-box">
                    <sp-map v-on:regiaoClicada="filtrarPorRegiao($event)" ref="mapa" id="mapaSP"
                        :habilitarAnimacaoClique="true"/>
                    <sp360-data-table id="tabelaServicos" ref="tabelaServicos" :apiMode="false"
                        :data="tabela.data" :fields="tabela.tableFields"
                        :sortFunctions="tabela.sortFunctions" :perPage="tabela.itemsPerPage" />
                </div>
            </sp-360-panel>
          </div>
        </div>

        <div class="row">
          <div class="flex col md12 sm12">
            <sp-360-panel :title="$t('assistencia.servicos.historicoTitulo')" :footerText=" $t('rodape.fonteData', {fonte: fonte, data: dataRef } )" :footerComplementar="$t('assistencia.servicos.historicoRodape')">
                <div class="">
                  <div class="row" id="chart">
                    <sp360-chart  class="historicoChart" id="chartHistorico" type="line" :data="chartHistorico.data" :options="chartHistorico.options" />
                  </div>
                  <div class="row">
                    <sp360-data-table id="tabelaHistorico" ref="tabelaHistorico" :apiMode="false"
                      :data="dadosHistoricos.data" :fields="dadosHistoricos.tableFields"
                      :sortFunctions="dadosHistoricos.sortFunctions" :perPage="dadosHistoricos.itemsPerPage" />
                  </div>
                </div>
            </sp-360-panel>
          </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import CorUtils from '@/utils/CorUtils'
import Constantes from '@/utils/ConstantesGlobais'
import MethGlob from '@/utils/MetodosGlobais'
import SpMap from '@/components/maps/360-maps/SPMap'
import SPMapaNomes from '@/utils/SPMapaNomes'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'
import SpCard from '@/components/ui/cards/SP360Card'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import Multiselect from 'vue-multiselect'
import VueMonthlyPicker from 'vue-monthly-picker'
import * as d3 from 'd3'

export default {
  name: 'servicosRegionalizados',

  components: {
    SpCard,
    SpMap,
    MethGlob,
    Sp360Chart,
    Sp360Panel,
    Sp360DataTable,
    Multiselect,
    VueMonthlyPicker,
    SPMapaNomes,
  },

  data () {
    return {
      fonte: null,
      dataRef: null,
      chartHistorico: { data: {}, options: {} },
      pickerConfig: {},
      minDate: 0,
      maxDate: 0,
      subSel: '',
      subs: [],
      tabela: {
        data: [],
        tableFields: [],
        sortFunctions: {
        },
        itemsPerPage: 12,
      },
      dadosConsolidados: [],
      dadosSub: [],
      dadosHistoricos: {
        data: [],
        tableFields: [
          {
            name: 'ano',
            sortField: 'ano',
            title: this.$t('assistencia.servicos.tabela.ano'),
            width: '3%',
          }, {
            name: 'mes',
            sortField: 'mes',
            title: this.$t('assistencia.servicos.tabela.mes'),
            width: '3%',
            callback: function (x) { return !isNaN(x) ? MethGlob.mapeiaMesAbreviacao(parseInt(x)).abrev : x },
          },
          {
            name: 'perc_medio_ocupacao',
            sortField: 'perc_medio_ocupacao',
            title: this.$t('assistencia.servicos.tabela.percentual_medio_ocupacao'),
            width: '8%',
            callback: function (x) {
              if (!isNaN(x)) {
                return MethGlob.formataPercentual(x)
              }
              return x
            },
          }, {
            name: 'media_vagas_ocupadas',
            sortField: 'media_vagas_ocupadas',
            title: this.$t('assistencia.servicos.tabela.media_vagas_ocupadas'),
            width: '8%',
            callback: function (x) { return x.toLocaleString('pt-BR') },
          }, {
            name: 'perc_medio_disponivel',
            sortField: 'perc_medio_disponivel',
            title: this.$t('assistencia.servicos.tabela.percentual_vacancia'),
            width: '8%',
            callback: function (x) {
              if (!isNaN(x)) {
                return MethGlob.formataPercentual(x)
              }
              return x
            },
          }, {
            name: 'media_vagas_disponiveis',
            sortField: 'media_vagas_disponiveis',
            title: this.$t('assistencia.servicos.tabela.media_vagas_disponiveis'),
            width: '8%',
            callback: function (x) { return x.toLocaleString('pt-BR') },
          }, {
            name: 'total_vagas_contratadas',
            sortField: 'total_vagas_contratadas',
            title: this.$t('assistencia.servicos.tabela.total_vagas_contratadas'),
            width: '8%',
            callback: function (x) { return x.toLocaleString('pt-BR') },
          }, {
            name: 'total_vagas_reais',
            sortField: 'total_vagas_reais',
            title: this.$t('assistencia.servicos.tabela.total_vagas_reais'),
            width: '8%',
            callback: function (x) { return x.toLocaleString('pt-BR') },
          }, {
            name: 'total_vagas_femininas',
            sortField: 'total_vagas_femininas',
            title: this.$t('assistencia.servicos.tabela.total_vagas_femininas'),
            width: '8%',
            callback: function (x) { return x.toLocaleString('pt-BR') },
          }, {
            name: 'total_vagas_masculinas',
            sortField: 'total_vagas_masculinas',
            title: this.$t('assistencia.servicos.tabela.total_vagas_masculinas'),
            width: '8%',
            callback: function (x) { return x.toLocaleString('pt-BR') },
          }, {
            name: 'perc_aumento_media_vagas_ocupadas',
            sortField: 'perc_aumento_media_vagas_ocupadas',
            title: this.$t('assistencia.servicos.tabela.variacao_periodo_anterior'),
            width: '10%',
            callback: function (x) {
              return MethGlob.check(x, '<i class="fa fa-arrow-up" style="color:green"/>', '<i class="fa fa-arrow-down" style="color:red"/>', 'N/D', true)
            },
          }, {
            name: 'media_vagas_ocupadas_periodo_passado',
            sortField: 'media_vagas_ocupadas_periodo_passado',
            title: this.$t('assistencia.servicos.tabela.ocupacao_media_periodo_anterior'),
            width: '10%',
            callback: function (x) {
              return x ? x.toLocaleString('pt-BR') : 'N/D'
              // return MethGlob.check(x, '<i class="fa fa-arrow-up" style="color:green"/>', '<i class="fa fa-arrow-down" style="color:red"/>',  "N/D", false )
            },
          },
        ],
        sortFunctions: {
        },
        itemsPerPage: 6,
      },
      dataInicial: 0,
      dataFinal: 0,
      monthLabels: [],
      dateFormat: 'MM/YYYY',
    }
  },

  created () {
    Promise.all([
      this.$store.dispatch('assistenciaSocial/buscarVagasAcolhimentoConsolidadoUltimoMes'),
      this.$store.dispatch('assistenciaSocial/buscarVagasAcolhimentoPorSubprefeituraNoUltimoMes'),
      this.$store.dispatch('assistenciaSocial/buscarPerfisOcupacoesAgrupadosNoUltimoMes', { agrupamento: 'SUBPREFEITURA' }),
      this.$store.dispatch('assistenciaSocial/vagasAcolhimentoHistoricoConsolidado', { agrupamento: 'SUBPREFEITURA' }),
      this.$store.dispatch('assistenciaSocial/vagasAcolhimentoHistoricoPorSubprefeitura', { dataInicio: null, dataFim: null, idTipoServico: 1 }),
      this.$store.dispatch('assistenciaSocial/vagasAcolhimentoHistoricoPossibilidadesFiltro', { agrupamento: 'SUBPREFEITURA' }),
      this.$store.dispatch('assistenciaSocial/vagasA'),
    ]).then((resposta) => {
      this.fonte = resposta[0].data.sigla_orgao + '-' + resposta[0].data.fonte
      this.dataRef = new Date(resposta[0].data.data_referencia_dado).toLocaleDateString('pt-BR')
      this.subs = _.orderBy(SPMapaNomes.slice(1), 'nome')
      this.dadosConsolidados = resposta[0].data.data
      this.dadosSub = resposta[1].data.data
      this.definirTabela()
      this.popularTabela(0)
      this.popularDadosHistoricos(resposta[3].data.data)
      this.popularGraficoDadosHistoricos(resposta[3].data.data)

      let dados = _.orderBy(resposta[4].data.data, 'total_vagas_reais')
      let municipio = _.remove(dados, (x) => { return x.id_subprefeitura <= 0 })
      this.pintarMapa(dados)
      this.chartHistorico.options = this.getLineChartOptions('assistencia.servicos.grafico.legendaX', 'assistencia.servicos.grafico.legendaY', 'line')
    })
  },

  methods: {
    pintarMapa (data) {
      let mapaCores = {
        claro: '#f1f1fa',
        medio: '#9c9cd4',
        escuro: '#3b3b72',
      }

      let dados = data

      let last = _.last(dados)
      let first = _.first(dados)

      let colorScale = d3.scaleLinear()
        .domain([first.total_vagas_reais, last.total_vagas_reais])
        .range([mapaCores.claro, mapaCores.escuro])

      dados.forEach(o => {
        if (o.id_subprefeitura) {
          this.$refs.mapa.pintarRegiao('sub' + o.id_subprefeitura, colorScale(o.total_vagas_reais))
        }
      })

      this.$refs.mapa.setLegenda(first.total_vagas_reais, last.total_vagas_reais, this.$t('assistencia.servicos.legenda'), 5)
      this.$refs.mapa.definirLegenda([mapaCores.claro, mapaCores.medio, mapaCores.escuro], [this.$t('mainDashboard.legendaTitulo'), this.$t('mainDashboard.legendaBaixa'), this.$t('mainDashboard.legendaMedia'), this.$t('mainDashboard.legendaAlta')])
    },

    definirTabela () {
      this.tabela.tableFields = [{
        name: 'tipo_servico',
        sortField: 'tipo_servico',
        title: this.$t('assistencia.servicos.tabela.tipo_servico'),
        width: '30%',
      }, {
        name: 'percentual_medio_ocupacao',
        sortField: 'percentual_medio_ocupacao',
        title: this.$t('assistencia.servicos.tabela.percentual_medio_ocupacao'),
        width: '10%',
        callback: function (x) {
          if (!isNaN(x)) {
            return MethGlob.formataPercentual(x)
          }
          return x
        },
      }, {
        name: 'media_vagas_disponiveis',
        sortField: 'media_vagas_disponiveis',
        title: this.$t('assistencia.servicos.tabela.media_vagas_disponiveis'),
        width: '10%',
        callback: function (x) { return x.toLocaleString('pt-BR') },
      }, {
        name: 'media_vagas_ocupadas',
        sortField: 'media_vagas_ocupadas',
        title: this.$t('assistencia.servicos.tabela.media_vagas_ocupadas'),
        width: '10%',
        callback: function (x) { return x.toLocaleString('pt-BR') },
      }, {
        name: 'total_vagas_contratadas',
        sortField: 'total_vagas_contratadas',
        title: this.$t('assistencia.servicos.tabela.total_vagas_contratadas'),
        width: '10%',
        callback: function (x) { return x.toLocaleString('pt-BR') },
      }, {
        name: 'total_vagas_femininas',
        sortField: 'total_vagas_femininas',
        title: this.$t('assistencia.servicos.tabela.total_vagas_femininas'),
        width: '10%',
        callback: function (x) { return x.toLocaleString('pt-BR') },
      }, {
        name: 'total_vagas_masculinas',
        sortField: 'total_vagas_masculinas',
        title: this.$t('assistencia.servicos.tabela.total_vagas_masculinas'),
        width: '10%',
        callback: function (x) { return x.toLocaleString('pt-BR') },
      }, {
        name: 'total_vagas_reais',
        sortField: 'total_vagas_reais',
        title: this.$t('assistencia.servicos.tabela.total_vagas_reais'),
        width: '10%',
        callback: function (x) { return x.toLocaleString('pt-BR') },
      },
      ]
    },

    updateMultiSelect (value) {
      if (!value) { // false
        value = this.subSel // use o ultimo selecionado
      }
      this.filtrarPorRegiao('sub' + value.id)
      this.updateDadosHistoricos(value.id)
    },
    // TODO : Refatorar
    filtrarPorRegiao (id) {
      let idNum = MethGlob.idSvgToNumeric(id)
      if (this.ultimoClickNomeSub !== id) {
        this.$refs.mapa.limparClick(this.ultimoClickNomeSub, false)
        this.ultimoClickNomeSub = id
        this.ultimoClickIdSub = idNum
        this.subSel = _.find(this.subs, (e) => e.id === idNum)
        this.$refs.mapa.emulateClick(id)
        // this.$refs.mapa.pintarRegiao(id, CorUtils.getCorPorNomeSp360(CorUtils.VERDE_MEDIO))
        this.popularTabela(idNum)
      } else {
        this.$refs.mapa.limparClick(this.ultimoClickNomeSub, false)
        this.ultimoClickNomeSub = null
        this.ultimoClickIdSub = 0
        this.subSel = null
        this.popularTabela(0)
      }
    },

    popularTabela (id) {
      let s = _.find(this.dadosSub, (e) => e.id_subprefeitura === id)
      this.tabela.data = (s) ? s.lista_tipo_servico : []
    },

    popularDadosHistoricos (dados) {
      this.dadosHistoricos.data = dados.slice(1).reverse()
      for (let index = 1; index <= 12; index++) {
        this.monthLabels.push(MethGlob.mapeiaMesAbreviacao(index).abrev)
      }
    },

    popularGraficoDadosHistoricos (dados) {
      let chartData = { datasets: [], labels: [] }
      let datasetVagas = {
        borderColor: CorUtils.getCorPorNomeSp360('vermelho-claro'),
        backgroundColor: CorUtils.getCorPorNomeSp360('vermelho-claro'),
        fill: false,
        data: [],
        yAxisID: 'y-axis-2',
        label: this.$t('assistencia.servicos.grafico.datasetLabelVagas'),
      }
      let datasetOcupacao = {
        borderColor: CorUtils.getCorPorNomeSp360('azul-columbia-claro'),
        backgroundColor: CorUtils.getCorPorNomeSp360('azul-columbia-claro'),
        fill: false,
        data: [],
        label: this.$t('assistencia.servicos.grafico.datasetLabel'),
      }
      let data = dados.slice(0)
      for (let index = 0; index < dados.length; index++) {
        const element = dados[index]
        let x = new Date(element.mes + '/01/' + element.ano)
        let y = element.perc_medio_ocupacao
        let z = element.total_vagas_contratadas

        datasetOcupacao.data.push({ t: x, y: y })
        datasetVagas.data.push({ t: x, y: z })
      }
      chartData.datasets.push(datasetOcupacao)
      chartData.datasets.push(datasetVagas)
      this.chartHistorico.data = chartData
    },

    updateDadosHistoricos (idSubprefeitura) {
      this.$store.dispatch('assistenciaSocial/vagasAcolhimentoHistoricoPorSubprefeitura', { dataInicio: this.dataInicial, dataFim: this.dataFinal, idTipoServico: 1, idSubprefeitura: (idSubprefeitura || this.ultimoClickIdSub) })
        .then(resposta => {
          this.popularDadosHistoricos(resposta.data.data)
          this.popularGraficoDadosHistoricos(resposta.data.data)
        })
        .catch(error => {
          console.error(error)
        })
    },

    getLineChartOptions (legendaX, legendaY, tipo, tooltipCustomizado = false, percentual = true, milhar = false) {
      return {
        tooltips: {
          mode: 'index',
          enabled: true,
          intersect: false,
          position: 'nearest',
          callbacks: {
            title: (tooltipItem, chart) => {
              const o = { year: 'numeric', month: 'short' }
              const date = new Date(tooltipItem[0].xLabel)
              return date.toLocaleDateString('pt-BR', o)
            },
            label: (tooltipItem, chart) => {
              let label = chart.datasets[tooltipItem.datasetIndex].label + '  ' || ''
              let value = ''
              if (chart.datasets[tooltipItem.datasetIndex].yAxisID === 'y-axis-2') {
                value = tooltipItem.yLabel.toLocaleString('pt-BR') 
              } else {
                value = tooltipItem.yLabel.toLocaleString('pt-BR')+ '%'
              }

              label += value
              return label
            },
          },
        },
        maintainAspectRatio: false,
        aspectRatio: 4,
        responsive: true,
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          },
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            fontColor: '#34495e',
            fontFamily: 'sans-serif',
            fontSize: 14,
            padding: 20,
            usePointStyle: true,
          },
        },
        scales: {
          xAxes: [{
            display: true,
            type: 'time',
            // distribution: 'series',
            time: {
              displayFormats: {
                quarter: 'MMM YYYY',
              },
            },
            ticks: {
              min: new Date('2014'),
            },
            scaleLabel: {
              display: true,
              labelString: this.$t(legendaX || 'LegendaX'),
            },
          }],
          yAxes: [{
            ticks: {
              min: 0, // minimum tick
              callback: (value) => MethGlob.formataPercentual(value),
            },
            id: 'y-axis-1',
            type: 'linear',
            position: 'left',
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t(legendaY || 'LegendaY'),
            },
          }, {
            id: 'y-axis-2',
            ticks: {
              min: 0, // minimum tick
              callback: (value) => value.toLocaleString('pt-BR'),
            },
            type: 'linear',
            position: 'right',
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t('assistencia.servicos.grafico.legendaX2'),
            },
            lineStyling: {
              spanGaps: false,
            },
          }],
        },
        plugins: {
          datalabels: {
            clamp: true,
            font: {
              size: 16,
              weight: 'bold',
            },
            anchor: 'start',
            align: 'end',
            color: '#000',
            display: false,
          },
        },
      }
    },
  },

}
</script>

<style lang="scss" scoped>
    .flex-box {
        display: flex;
    }
    #mapaSP{
       width: 25%;
    }
    #tabelaServicos{
        width: 75%;
        height: auto
    }
    .historicoChart {
        max-height: 20rem
    }
    #tabelaHistorico{
        width: 100%;
    }
    .fa-arrow-up{
      color: green
    }
    .fa-arrow-down{
      color: red
    }
</style>
